'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var nthHookTranslations = require('@narvar/nth-hook-translations');
var OptInTemplate = require('../OptInTemplate.js');
var LineLogin = require('./LineLogin.js');
var LineLogo = require('../../common/LineLogo.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

const LineOptIn = ({
  featureName,
  layout,
  channel,
  notificationPreferencesState
}) => {
  const {
    notificationCenterLineOptinMessage
  } = nthHookTranslations.useTranslations();

  // TODO: Log an error?
  if (!notificationPreferencesState?.lineLoginUrl) return null;
  const lineOptInChannelProps = {
    optInChannelInput: /*#__PURE__*/React__default["default"].createElement(LineLogin["default"], {
      layout: layout,
      url: notificationPreferencesState?.lineLoginUrl,
      featureName: featureName
    }),
    optInIcon: /*#__PURE__*/React__default["default"].createElement(LineLogo["default"], null),
    optInMessageText: notificationCenterLineOptinMessage || '',
    landscapeColWidths: [7, 5]
  };
  return /*#__PURE__*/React__default["default"].createElement(OptInTemplate["default"], {
    featureName: featureName,
    layout: layout,
    channel: channel,
    optInChannelProps: lineOptInChannelProps
  });
};
var LineOptIn$1 = nthHookTranslations.withTranslationsProvider(LineOptIn, {
  translationKeys: ['notificationCenterLineOptinMessage']
});

exports["default"] = LineOptIn$1;
